// Outlet collection sites (branches) as GET /collection_site/{orgId} returns them.

import { DEMO_OUTLET_ORG_ID, DEMO_SITES, daysAgo, iso, siteById, type DemoSite } from '../core';
import type { CollectionSiteSchema } from '../../types/collection-site.type';

const AREA_M2 = [3200, 2400, 2100, 18500, 2600, 2200];

function toCollectionSite(site: DemoSite, index: number): CollectionSiteSchema {
  return {
    id: site.id,
    latitude: site.lat,
    longitude: site.lng,
    google_maps_url: `https://www.google.com/maps?q=${site.lat},${site.lng}`,
    area: AREA_M2[index] ?? 2000,
    organization_id: DEMO_OUTLET_ORG_ID,
    status: 'active',
    data: {
      name: site.name_en,
      name_ar: site.name_ar,
      code: site.code,
      address: site.address,
      city: site.city,
      city_ar: site.city_ar,
      site_type: site.site_type,
      opening_hours: site.opening_hours,
      manager_name: site.manager_name,
      contact_info: { name: site.manager_name, phone: site.phone },
    },
    created_at: iso(daysAgo(400 - index * 9)),
    updated_at: iso(daysAgo(20 + index * 3)),
  };
}

/** Collection sites of an organisation (only the outlet has branches). */
export function collectionSitesFor(orgId: string | null | undefined): CollectionSiteSchema[] {
  if (orgId !== DEMO_OUTLET_ORG_ID) return [];
  return DEMO_SITES.map(toCollectionSite);
}

export function siteName(siteId: string | null | undefined): string | null {
  return siteId ? siteById(siteId)?.name_en ?? null : null;
}
